// extracted by mini-css-extract-plugin
module.exports = {"body":"_b490016","cms":"_1587854"};